import { CategoryList } from '../interfaces/categories';

/**
 * Flattens a nested category structure into a single-level array
 * @param categories - The nested categories to flatten
 * @returns A flattened array of categories
 */
export const flattenCategories = (categories: CategoryList[]): CategoryList[] => {
  return categories.reduce<CategoryList[]>((acc, category) => {
    // Add the current category with empty subcategories
    acc.push({ ...category, subcategories: [] });

    // If it has subcategories, recursively flatten them
    if (category.subcategories?.length) {
      acc.push(...flattenCategories(category.subcategories));
    }

    return acc;
  }, []);
};

/**
 * Filters categories based on a search query
 * @param categories - The categories to filter
 * @param query - The search query
 * @returns Filtered categories
 */
export const filterCategories = (categories: CategoryList[], query: string): CategoryList[] => {
  if (!query.trim()) return categories;

  const lowerQuery = query.toLowerCase().trim();

  return categories.filter(
    (category) =>
      category.category_name.toLowerCase().includes(lowerQuery) ||
      category.category_title.toLowerCase().includes(lowerQuery)
  );
};
